import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

export default function AdminMemos() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const [tab, setTab] = useState('compose')
  const [subject, setSubject] = useState('')
  const [body, setBody] = useState('')
  const [priority, setPriority] = useState('general')
  const [recipients, setRecipients] = useState(['All Staff'])
  const [isUrgent, setIsUrgent] = useState(false)
  const [requiresAck, setRequiresAck] = useState(false)
  const [sent, setSent] = useState(false)
  const [selectedEmployee, setSelectedEmployee] = useState('Jamie Mitchell')
  const [replyText, setReplyText] = useState('')
  const [readPopover, setReadPopover] = useState(null)
  const [threads, setThreads] = useState({
    'Jamie Mitchell': [
      { from: 'Jamie Mitchell', text: 'Hi Tiffany, just wanted to check on the status of my time off request for April 23-25. Thanks!', time: 'Apr 2, 9:14am', isAdmin: false },
      { from: 'Tiffany Gallagher', text: 'Hi Jamie! I saw it come through -- reviewing it today and will get back to you by end of day.', time: 'Apr 2, 10:30am', isAdmin: true },
    ],
    'Sam Rivera': [
      { from: 'Sam Rivera', text: 'Hey, I submitted my timesheet for week 13 but got an automated reminder. Is it showing as received on your end?', time: 'Apr 1, 2:05pm', isAdmin: false },
    ],
    'Dana Lee': [
      { from: 'Dana Lee', text: 'Quick question about the new parking policy -- do company vehicles need to be registered too?', time: 'Mar 26, 11:20am', isAdmin: false },
      { from: 'Tiffany Gallagher', text: 'Great question Dana! Company vehicles are already on file, so only personal vehicles need to be registered.', time: 'Mar 26, 12:45pm', isAdmin: true },
    ],
    'Kim Park': [],
    'Marcus Thomas': [],
    'Paula Reyes': [],
  })

  const recipientOptions = ['All Staff','Operations','Administrative','Field Staff','Customer Service','Managers Only']

  const sentMemos = [
    { subject: 'Spring Schedule Change - All Staff', recipients: 'All Staff (18)', date: 'Today',  read: '8/18',  ack: '--',   unread: ['Sam Rivera','Kim Park','Dana Lee','Marcus Thomas','Jordan Collins','Paula Reyes','Alex Kim','Chris Morgan','Taylor Reed','Jamie Ortiz'] },
    { subject: 'Employee Appreciation Week',         recipients: 'All Staff (18)', date: 'Mar 30', read: '18/18', ack: '--',   unread: [] },
    { subject: 'Updated Parking Policy',             recipients: 'All Staff (18)', date: 'Mar 25', read: '17/18', ack: '14/18', unread: ['Marcus Thomas'], unacked: ['Marcus Thomas','Jordan Collins','Paula Reyes','Chris Morgan'] },
    { subject: 'Q1 Performance Summary',             recipients: 'Managers (3)',   date: 'Mar 20', read: '3/3',   ack: '3/3',  unread: [] },
    { subject: 'Safety Reminder - Field Staff',      recipients: 'Field Staff (5)',date: 'Mar 15', read: '5/5',   ack: '5/5',  unread: [] },
    { subject: 'New Hire Welcome - Jamie Mitchell',  recipients: 'All Staff (18)', date: 'Jan 12', read: '18/18', ack: '--',   unread: [] },
  ]

  function toggleRecipient(r) {
    setRecipients(prev => prev.includes(r) ? prev.filter(x => x !== r) : [...prev, r])
  }

  function handleSend() {
    if (!subject.trim()) { alert('Please add a subject line.'); return }
    if (!body.trim()) { alert('Please write your memo.'); return }
    setSent(true)
    setTimeout(() => { setSent(false); setSubject(''); setBody(''); }, 4000)
  }

  function handleReply() {
    if (!replyText.trim()) return
    setThreads(t => ({
      ...t,
      [selectedEmployee]: [...(t[selectedEmployee] || []), {
        from: 'Tiffany Gallagher',
        text: replyText,
        time: 'Just now',
        isAdmin: true,
      }]
    }))
    setReplyText('')
  }

  const priorityColor = { general:'#6B7D6B', important:'#C4843A', urgent:'#A0392B', policy:'#4A6B8A' }
  const employees = Object.keys(threads)
  const unreadCounts = { 'Jamie Mitchell': 0, 'Sam Rivera': 1, 'Dana Lee': 0, 'Kim Park': 0, 'Marcus Thomas': 0, 'Paula Reyes': 0 }

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}} onClick={()=>setReadPopover(null)}>
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Memos & Messages</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Compose announcements and message employees directly</p>
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden',marginBottom:16,width:'fit-content'}}>
        {[['compose','Compose'],['sent','Sent Memos'],['direct','Direct Messages']].map(([key,label],i,arr)=>(
          <button key={key} onClick={()=>setTab(key)}
            style={{padding:'8px 24px',border:'none',borderRight:i<arr.length-1?'1px solid #EDE6DA':'none',background:tab===key?accent:'#fff',color:tab===key?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s',position:'relative'}}>
            {label}
            {key==='direct' && Object.values(unreadCounts).some(v=>v>0) && (
              <span style={{position:'absolute',top:4,right:4,width:7,height:7,borderRadius:'50%',background:'#A0392B'}}/>
            )}
          </button>
        ))}
      </div>

      {/* Compose */}
      {tab === 'compose' && (
        <div style={{display:'grid',gridTemplateColumns:'1fr 280px',gap:14}}>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>New Memo</div>
            </div>
            <div style={{padding:'16px',display:'flex',flexDirection:'column',gap:14}}>
              {sent && (
                <div style={{display:'flex',alignItems:'center',gap:8,background:'rgba(74,124,89,0.1)',border:'1px solid #4A7C59',borderRadius:8,padding:'10px 14px'}}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
                  <span style={{fontSize:12,color:'#4A7C59',fontWeight:500}}>Memo sent! All recipients have been notified.</span>
                </div>
              )}
              <div>
                <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}}>Subject Line</label>
                <input value={subject} onChange={e=>setSubject(e.target.value)} placeholder="What is this memo about?" style={{width:'100%',padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}/>
              </div>
              <div>
                <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}}>Priority</label>
                <select value={priority} onChange={e=>setPriority(e.target.value)} style={{width:'100%',padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',color:'#2B2B2B'}}>
                  <option value="general">General Announcement</option>
                  <option value="important">Important - Requires Attention</option>
                  <option value="urgent">Urgent</option>
                  <option value="policy">Policy Update</option>
                </select>
              </div>
              <div>
                <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:8}}>Recipients</label>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:6}}>
                  {recipientOptions.map(r=>(
                    <button key={r} onClick={()=>toggleRecipient(r)}
                      style={{padding:'7px 10px',border:`1px solid ${recipients.includes(r)?accent:'#EDE6DA'}`,borderRadius:6,background:recipients.includes(r)?accentBg:'#fff',color:recipients.includes(r)?accent:'#4A4A4A',fontSize:11,fontWeight:500,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",textAlign:'left',transition:'all 0.15s'}}>
                      {r}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label style={{display:'block',fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}}>Message</label>
                <textarea value={body} onChange={e=>setBody(e.target.value)} rows={8} placeholder="Write your memo here..." style={{width:'100%',padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',resize:'vertical',color:'#2B2B2B',lineHeight:1.7}}/>
              </div>
              <div style={{marginBottom:10}}>
            <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',padding:'8px 14px',borderRadius:6,border:'1px solid '+(isUrgent?'#A0392B':'#EDE6DA'),background:isUrgent?'rgba(160,57,43,0.06)':'#F7F2EB',transition:'all 0.15s'}}>
              <input type="checkbox" checked={isUrgent} onChange={e=>setIsUrgent(e.target.checked)} style={{accentColor:'#A0392B',width:14,height:14}}/>
              <span style={{fontSize:12,fontWeight:600,color:isUrgent?'#A0392B':'#4A4A4A'}}>Mark as URGENT — displays emergency banner on all employee dashboards</span>
            </label>
          </div>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <label style={{display:'flex',alignItems:'center',gap:8,fontSize:12,color:'#4A4A4A',cursor:'pointer'}}>
                  <input type="checkbox" checked={requiresAck} onChange={e=>setRequiresAck(e.target.checked)} style={{accentColor:accent,width:14,height:14}}/>
                  Require employee acknowledgment
                </label>
                <button onClick={handleSend} style={{padding:'9px 20px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                  {isUrgent ? '🚨 Send URGENT Memo' : 'Send Memo →'}
                </button>
              </div>
            </div>
          </div>

          {/* Preview */}
          <div style={{display:'flex',flexDirection:'column',gap:14}}>
            <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
              <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA'}}>
                <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Live Preview</div>
              </div>
              <div style={{padding:'14px'}}>
                <div style={{background:'#F7F2EB',border:'1px solid #EDE6DA',borderRadius:8,padding:'14px'}}>
                  <div style={{display:'flex',alignItems:'center',gap:8,paddingBottom:10,borderBottom:'1px solid #EDE6DA',marginBottom:10}}>
                    <div style={{width:26,height:26,borderRadius:'50%',border:`1px solid ${accent}`,display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'Georgia,serif',fontSize:10,fontWeight:700,color:accent}}>DC</div>
                    <div>
                      <div style={{fontSize:11,color:'#2B2B2B',fontWeight:600}}>Demo Company Co.</div>
                      <div style={{fontSize:9,color:'#8A9E8A'}}>Internal Memo · April 2, 2025</div>
                    </div>
                  </div>
                  {priority !== 'general' && (
                    <div style={{marginBottom:8}}>
                      <span style={{fontSize:10,padding:'2px 8px',borderRadius:8,fontWeight:600,background:priorityColor[priority]+'22',color:priorityColor[priority]}}>{priority==='important'?'Important':priority==='urgent'?'Urgent':'Policy Update'}</span>
                    </div>
                  )}
                  <div style={{fontFamily:'Georgia,serif',fontSize:13,color:'#2B2B2B',fontWeight:600,marginBottom:8}}>{subject || 'Your subject will appear here'}</div>
                  <div style={{fontSize:11,color:'#4A4A4A',lineHeight:1.7,whiteSpace:'pre-wrap'}}>{body || 'Your message will appear here as you type...'}</div>
                  <div style={{marginTop:10,paddingTop:8,borderTop:'1px solid #EDE6DA',fontSize:9,color:'#8A9E8A'}}>Sent by Tiffany Gallagher · Administrator · Demo Company Co.</div>
                </div>
              </div>
            </div>
            <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'14px 16px'}}>
              <div style={{fontSize:12,fontWeight:600,color:'#2B2B2B',marginBottom:10}}>Delivery Options</div>
              {[['In-app notification',true],['Email notification',false],['Require acknowledgment',requiresAck]].map(([label,checked])=>(
                <label key={label} style={{display:'flex',alignItems:'center',gap:8,fontSize:12,color:'#4A4A4A',marginBottom:8,cursor:'pointer'}}>
                  <input type="checkbox" defaultChecked={checked} style={{accentColor:accent,width:14,height:14}}/>
                  {label}
                </label>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Sent */}
      {tab === 'sent' && (
        <div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:16}}>
            {[{label:'Sent This Month',value:'7'},{label:'Avg Read Rate',value:'91%'},{label:'Acknowledged',value:'38'},{label:'Outstanding',value:'4'}].map(s=>(
              <div key={s.label} style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'12px 16px'}}>
                <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:500,marginBottom:4}}>{s.label}</div>
                <div style={{fontFamily:'Georgia,serif',fontSize:'1.5rem',color:'#2B2B2B',fontWeight:600}}>{s.value}</div>
              </div>
            ))}
          </div>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
              <thead>
                <tr style={{background:'#F7F2EB'}}>
                  {['Subject','Recipients','Sent','Read','Acknowledged'].map(h=>(
                    <th key={h} style={{textAlign:'left',padding:'8px 16px',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,borderBottom:'1px solid #EDE6DA'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sentMemos.map((m,i)=>(
                  <tr key={i} style={{borderBottom:'1px solid #EDE6DA'}}
                    onMouseEnter={e=>e.currentTarget.style.background='rgba(184,115,74,0.04)'}
                    onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                    <td style={{padding:'12px 16px',fontWeight:500,color:'#2B2B2B'}}>{m.subject}</td>
                    <td style={{padding:'12px 16px',color:'#6B7D6B'}}>{m.recipients}</td>
                    <td style={{padding:'12px 16px',color:'#8A9E8A'}}>{m.date}</td>
                    <td style={{padding:'12px 16px',position:'relative'}}>
                      {m.unread && m.unread.length > 0 ? (
                        <span
                          onClick={e=>{e.stopPropagation();setReadPopover(readPopover===i+'-read'?null:i+'-read')}}
                          style={{fontSize:11,fontWeight:600,color:accent,cursor:'pointer',textDecoration:'underline',textDecorationStyle:'dotted'}}>
                          {m.read}
                        </span>
                      ) : (
                        <span style={{fontSize:11,fontWeight:600,color:'#4A7C59'}}>{m.read}</span>
                      )}
                      {readPopover===i+'-read' && m.unread && m.unread.length > 0 && (
                        <div onClick={e=>e.stopPropagation()} style={{position:'absolute',top:'100%',left:0,zIndex:100,background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,boxShadow:'0 4px 20px rgba(0,0,0,0.12)',padding:'12px 14px',minWidth:200}}>
                          <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:8}}>Has not read</div>
                          {m.unread.map((name,j)=>(
                            <div key={j} style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
                              <div style={{width:22,height:22,borderRadius:'50%',background:'rgba(160,57,43,0.1)',color:'#A0392B',fontSize:9,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                                {name.split(' ').map(n=>n[0]).join('')}
                              </div>
                              <span style={{fontSize:12,color:'#4A4A4A'}}>{name}</span>
                            </div>
                          ))}
                          <button style={{marginTop:8,width:'100%',padding:'5px',background:accent,border:'none',borderRadius:5,color:'#fff',fontSize:10,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                            Send Reminder
                          </button>
                        </div>
                      )}
                    </td>
                    <td style={{padding:'12px 16px',color:'#8A9E8A'}}>{m.ack}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Direct Messages */}
      {tab === 'direct' && (
        <div style={{display:'grid',gridTemplateColumns:'220px 1fr',gap:14,minHeight:500}}>
          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
            <div style={{padding:'10px 14px',borderBottom:'1px solid #EDE6DA',fontSize:12,fontWeight:600,color:'#2B2B2B'}}>Employees</div>
            {employees.map(emp => {
              const lastMsg = threads[emp]?.[threads[emp].length - 1]
              const unread = unreadCounts[emp] || 0
              return (
                <div key={emp} onClick={() => setSelectedEmployee(emp)}
                  style={{padding:'10px 14px',borderBottom:'1px solid #EDE6DA',cursor:'pointer',background:selectedEmployee===emp?accentBg:'transparent',borderLeft:selectedEmployee===emp?`3px solid ${accent}`:'3px solid transparent'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:2}}>
                    <div style={{fontSize:12,fontWeight:600,color:selectedEmployee===emp?accent:'#2B2B2B'}}>{emp.split(' ')[0]}</div>
                    {unread > 0 && <span style={{width:16,height:16,borderRadius:'50%',background:'#A0392B',color:'#fff',fontSize:9,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center'}}>{unread}</span>}
                  </div>
                  <div style={{fontSize:11,color:'#8A9E8A',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                    {lastMsg ? lastMsg.text.slice(0,35)+'...' : 'No messages yet'}
                  </div>
                </div>
              )
            })}
          </div>

          <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden',display:'flex',flexDirection:'column'}}>
            <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',gap:10}}>
              <div style={{width:32,height:32,borderRadius:'50%',background:accentBg,color:accent,display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700}}>
                {selectedEmployee.split(' ').map(n=>n[0]).join('')}
              </div>
              <div>
                <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B'}}>{selectedEmployee}</div>
                <div style={{fontSize:10,color:'#6B7D6B'}}>Direct message thread</div>
              </div>
            </div>
            <div style={{flex:1,overflowY:'auto',padding:'16px',display:'flex',flexDirection:'column',gap:12,minHeight:300}}>
              {(threads[selectedEmployee] || []).length === 0 ? (
                <div style={{textAlign:'center',color:'#8A9E8A',fontSize:12,marginTop:'3rem'}}>No messages yet. Send the first one!</div>
              ) : (
                (threads[selectedEmployee] || []).map((msg, i) => (
                  <div key={i} style={{display:'flex',flexDirection:'column',alignItems:msg.isAdmin?'flex-end':'flex-start'}}>
                    <div style={{maxWidth:'70%',padding:'10px 14px',borderRadius:msg.isAdmin?'12px 12px 4px 12px':'12px 12px 12px 4px',background:msg.isAdmin?accent:'#F7F2EB',color:msg.isAdmin?'#fff':'#2B2B2B',fontSize:13,lineHeight:1.6}}>
                      {msg.text}
                    </div>
                    <div style={{fontSize:10,color:'#8A9E8A',marginTop:3}}>{msg.isAdmin?'You':'Employee'} · {msg.time}</div>
                  </div>
                ))
              )}
            </div>
            <div style={{padding:'12px 16px',borderTop:'1px solid #EDE6DA',display:'flex',gap:10,alignItems:'flex-end'}}>
              <textarea value={replyText} onChange={e=>setReplyText(e.target.value)}
                onKeyDown={e=>{if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();handleReply()}}}
                placeholder={`Message ${selectedEmployee.split(' ')[0]}... (Enter to send)`}
                rows={2} style={{flex:1,padding:'9px 13px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:13,fontFamily:"'Montserrat',sans-serif",outline:'none',resize:'none',color:'#2B2B2B'}}/>
              <button onClick={handleReply} disabled={!replyText.trim()}
                style={{padding:'9px 18px',background:replyText.trim()?accent:'#EDE6DA',border:'none',borderRadius:6,color:replyText.trim()?'#fff':'#8A9E8A',fontSize:12,fontWeight:600,cursor:replyText.trim()?'pointer':'default',fontFamily:"'Montserrat',sans-serif",whiteSpace:'nowrap'}}>
                Send →
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
